import type { TokenizerExtension } from 'marked';
import { ISO_DATE_TOKEN_NAME, type IsoDateToken } from './date-types';

// Full ISO 8601 datetime — time component required to avoid ambiguity with plain date strings
const ISO_DATE_PATTERN =
  /^\d{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12]\d|3[01])T(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d+)?(?:Z|[+-](?:[01]\d|2[0-3]):?[0-5]\d)/;
const MARKED_INLINE_TOKEN_LEVEL = 'inline';

export function createIsoDateTokenizerExtension(): TokenizerExtension {
  return {
    name: ISO_DATE_TOKEN_NAME,
    level: MARKED_INLINE_TOKEN_LEVEL,
    start(src) {
      const m = src.match(/\d{4}-\d{2}-\d{2}T/);
      return m?.index;
    },
    tokenizer(src) {
      const match = ISO_DATE_PATTERN.exec(src);
      if (!match) {
        return undefined;
      }

      const isoString = match[0];
      const token: IsoDateToken = {
        type: ISO_DATE_TOKEN_NAME,
        raw: isoString,
        text: isoString,
        isoString,
      };

      return token;
    },
  };
}
